import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import "./JournalList.css";

export default function JournalList() {
  const [journals, setJournals] = useState([]);
  const [loading, setLoading] = useState(true);

  // Get backend URL from env var and strip trailing slash if any
  const backendBaseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

  useEffect(() => {
    async function fetchJournals() {
      try {
        const resp = await api.get("journals");
        setJournals(resp.data);
      } catch (err) {
        alert("Failed to load journals: " + (err.response?.data?.msg || err.message));
      } finally {
        setLoading(false);
      }
    }
    fetchJournals();
  }, []);

  if (loading) return <div>Loading journals...</div>;
  if (journals.length === 0) return <div>No journals found.</div>;

  return (
    <div className="journal-list">
      {journals.map(journal => (
        <Link
          to={`/journals/${journal._id}`}
          key={journal._id}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="journal-card">
            <h2>{journal.title}</h2>
            <p>
              {journal.description.length > 150
                ? journal.description.substring(0, 150) + "..."
                : journal.description}
            </p>
            <p><strong>Location:</strong> {journal.location}</p>
            {journal.photos && journal.photos.length > 0 && (
              <img
                src={
                  journal.photos[0].startsWith("http")
                    ? journal.photos[0]
                    : `${backendBaseUrl}${journal.photos[0]}`
                }
                alt="Thumbnail"
                style={{ width: 120, height: 90, objectFit: "cover", borderRadius: 6 }}
              />
            )}
            
          </div>
        </Link>
      ))}
    </div>
  );
}
